import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Switch, Row } from "antd";
import Axios from "axios";

const OnlineArticlePreview = ({
  activeArticle: { html, title, isPublished },
  match,
  history
}) => {
  const [publication, setPublication] = useState(isPublished);
  useEffect(() => {
    document.getElementById("article_preview").innerHTML = html;
  }, [html]);
  return (
    <React.Fragment>
      <Row
        justify="space-between"
        type="flex"
        className="mb-3 bg-white pl-4 pr-4 pt-2 pb-2"
      >
        <h3 className="title is-3 mt-3"> Online Article Preview : {title} </h3>
        <div
          className="mt-3"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "start"
          }}
        >
          <Button
            type="primary"
            onClick={() =>
              history.push("/article/online/" + match.params._id + "/edit")
            }
          >
            Edit
          </Button>
        </div>
      </Row>
      <div
        id="article_preview"
        style={{
          maxWidth: 1160,
          margin: "0 auto",
          backgroundColor: "white",
          textAlign: "center"
        }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Switch
          checked={publication}
          style={{ marginRight: 24, marginTop: 4 }}
          onChange={() => setPublication(!publication)}
        />
        <Button
          type="primary"
          onClick={async () => {
            await Axios.put(`/publish-online-article/${match.params._id}`, {
              isPublished: publication
            });
            history.push("/articles");
          }}
        >
          Save publication
        </Button>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  activeArticle: state.articles.activeArticle
});

export default connect(mapStateToProps)(OnlineArticlePreview);
